import React from 'react'
import { withTranslation } from 'react-i18next'
import { publicationList } from '../data/archive'
import { publicRoute } from '../helpers/publicRoute'

const PageHeadingFragment = ({ t, pageTitle, acronym, researchCenter }) => (
  <div className="uk-text-left" data-uk-grid>
    <div className="uk-width-auto">
      <div className="uk-card uk-card-default uk-border-rounded">
        <div className="uk-card-header uk-padding-small">
          <div className="uk-grid-small" data-uk-grid>
            <div className="uk-width-expand">
              <h1>{t(pageTitle)}</h1>
              <small><strong>{t(acronym)}</strong> ● {t(researchCenter)}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const BoardMembersListFragment = ({ t, list }) => (
  list.map(item => typeof item === 'object'
    ? <li>
        {item.affiliation && <div><small>{t(String(item.affiliation))}</small></div>}
        <div><small>{t(String(item.position))}</small> {item.name}</div>
        <div>{item.title && <span className="uk-label uk-label-success">{t(String(item.title))}</span>}</div>
      </li>
    : <li>{item}</li>)
)

const ArchiveExpoFragment = ({ t, list }) => {
  return (
    <div className="uk-position-relative uk-visible-toggle uk-light uk-margin-top" tabIndex="-1" data-uk-slider="finite: true">
      <ul className="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-5@m" data-uk-switcher="animation: uk-animation-fade">
        {list.map(item => 
          <li key={`${item.authorName}-${item.articleTitle}`}>
            <a href="/">
              <div className="uk-card uk-card-default">
                <div className="uk-card-media-top">
                  <img src={publicRoute(item.thumbnailSource)} alt="" />
                </div>
                <div className="uk-card-body uk-padding-small">
                  <p className="uk-card-title uk-text-truncate"><small>{item.authorName}</small></p>
                  <p className="uk-card-title uk-text-truncate">{item.articleTitle}</p>
                </div>
              </div>
            </a>
          </li>
        )}
      </ul>

      <ul className="uk-slider-nav uk-dotnav uk-flex-center uk-section uk-section-primary uk-light uk-padding-small" />

      <ul className="uk-switcher">
        {list.map(item => (
          <li key={`${item.authorName}-${item.articleTitle}`}>
            <div className="uk-section uk-section-primary uk-light uk-padding-small">
              <div className="uk-container">
                <div className="uk-child-width-1-2@m" data-uk-grid>
                  <div>
                    <img src={publicRoute(item.thumbnailSource)} alt={`${item.authorName}-${item.articleTitle}`} />
                  </div>
                  <div>
                    <h3>{item.authorName}</h3>
                    <h1>{item.articleTitle}</h1>
                    <a href={publicRoute(item.filePath)} target="_blank" rel="noopener noreferrer" className="uk-button uk-button-default"><span uk-icon="icon: download"></span> Download <span uk-icon="icon: file-pdf"></span></a>
                    <h6>{item.issueID}</h6>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

const PublicationListFragment = ({ t, list }) => {
  return (
    <table className="uk-table uk-table-striped uk-table-hover">
      <thead>
        <tr>
          <th className="uk-table-expand">{t('publicationList.year')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {list.reverse().map(item => (<tr>
          <td>{item.year}</td>
          <td>
            <span uk-icon="icon: download"></span>
            <a href={publicRoute(item.filePath)}>{t('publicationList.download')}</a>
          </td>
        </tr>))}
      </tbody>
    </table>
  )
}

const PageHeading = withTranslation()(PageHeadingFragment)
const PublicationList = withTranslation()(PublicationListFragment)
const BoardMembersList = withTranslation()(BoardMembersListFragment)
const ArchiveExpo = withTranslation()(ArchiveExpoFragment)
export { PageHeading, BoardMembersList, ArchiveExpo, PublicationList }